var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1065_10558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1065_10558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.52571 23.9166C7.94568 23.9166 7.44917 23.7101 7.03617 23.2971C6.62317 22.8841 6.41667 22.3876 6.41667 21.8076V6.99993H6.125C5.87708 6.99993 5.66932 6.91603 5.50171 6.74823C5.3339 6.58042 5.25 6.37256 5.25 6.12464C5.25 5.87653 5.3339 5.66877 5.50171 5.50135C5.66932 5.33374 5.87708 5.24993 6.125 5.24993H10.5C10.5 4.9643 10.6006 4.72085 10.8019 4.5196C11.0029 4.31855 11.2463 4.21802 11.5319 4.21802H16.4681C16.7537 4.21802 16.9971 4.31855 17.1981 4.5196C17.3994 4.72085 17.5 4.9643 17.5 5.24993H21.875C22.1229 5.24993 22.3307 5.33384 22.4983 5.50164C22.6661 5.66945 22.75 5.87731 22.75 6.12523C22.75 6.37334 22.6661 6.5811 22.4983 6.74852C22.3307 6.91613 22.1229 6.99993 21.875 6.99993H21.5833V21.8076C21.5833 22.3876 21.3768 22.8841 20.9638 23.2971C20.5508 23.7101 20.0543 23.9166 19.4743 23.9166H8.52571ZM19.8333 6.99993H8.16667V21.8076C8.16667 21.9124 8.20031 21.9984 8.26758 22.0657C8.33486 22.133 8.4209 22.1666 8.52571 22.1666H19.4743C19.5791 22.1666 19.6651 22.133 19.7324 22.0657C19.7997 21.9984 19.8333 21.9124 19.8333 21.8076V6.99993ZM11.8466 19.8333C12.0945 19.8333 12.3023 19.7495 12.4699 19.5819C12.6373 19.414 12.721 19.2062 12.721 18.9583V10.2083C12.721 9.96035 12.6371 9.75249 12.4693 9.58468C12.3017 9.41707 12.0939 9.33327 11.8458 9.33327C11.5978 9.33327 11.3901 9.41707 11.2225 9.58468C11.055 9.75249 10.9713 9.96035 10.9713 10.2083V18.9583C10.9713 19.2062 11.0551 19.414 11.2228 19.5819C11.3906 19.7495 11.5985 19.8333 11.8466 19.8333ZM16.1543 19.8333C16.4022 19.8333 16.6099 19.7495 16.7775 19.5819C16.945 19.414 17.0287 19.2062 17.0287 18.9583V10.2083C17.0287 9.96035 16.9449 9.75249 16.7773 9.58468C16.6094 9.41707 16.4015 9.33327 16.1534 9.33327C15.9055 9.33327 15.6977 9.41707 15.5301 9.58468C15.3627 9.75249 15.279 9.96035 15.279 10.2083V18.9583C15.279 19.2062 15.3629 19.414 15.5307 19.5819C15.6983 19.7495 15.9061 19.8333 16.1543 19.8333Z",
    fill: "#D32F2F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.309d9b7e683515288cecde49b4dca1a3.svg";
export { ForwardRef as ReactComponent };